import React, { useEffect } from "react";
import { connect } from "react-redux";
// import { Redirect } from "react-router-dom";
import { login3 } from "../../actions";
// import { getIsAuthenticated,getInitAppSuccess } from "../../reducers";
import DotLoader from "../Loaders/DotLoader";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const LoginSAML = (props) => {
  const { login3 } = props;

  useEffect(() => {
    login3({});
  }, [login3]);

  return (
    <Wrapper>
      <DotLoader />
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    //  isAuthenticated: getIsAuthenticated(state),
    // initAppSuccess: getInitAppSuccess(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login3: ({ orgId }) => {
      dispatch(login3({ orgId, strategy: "saml" }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginSAML);
